<c-card class="mb-5">
    <c-card-header>
      <div class="d-flex justify-content-between align-items-center py-2">
        <!-- <app-date-to-date-search (dateToDateSearch)="dateToDateSearch($event)"></app-date-to-date-search> -->
        <c-button-group class="btn btn-primary" role="group">
          <!-- <button cButton class="btn-primary" (click)="handleDoc('pdf')">
            PDF
          </button>
          <button cButton class="btn-primary" (click)="handleDoc('csv')">
            CSV
          </button> -->
           <button cButton class="btn-primary" (click)="handleDoc('xls')">
            XLS
          </button>
                            
        </c-button-group>
      </div>
    </c-card-header>
    <c-card-body>
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 responsive-table">
  
          <!-- <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
              <div class="header-name d-flex align-items-center" (click)="sortData('name')">
            Name
                <mat-icon class="sorting-icon" *ngIf="sorting.column === 'name'">
                  {{ sorting.direction === 1 ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </div>
              <mat-form-field>
                <input matInput [matDatepicker]="picker" (dateInput)="onDateChange($event, 'name')"
                  (dateChange)="onDateChange($event, 'name')" placeholder="MM/DD/YYYY">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.name}}
            </td>
          </ng-container> -->

          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
              <div class="header-name d-flex align-items-center" (click)="sortData('createdAt')">
                Date
                <mat-icon class="sorting-icon" *ngIf="sorting.column === 'createdAt'">
                  {{ sorting.direction === 1 ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </div>
              <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'createdAt')">
                <input matInput placeholder="Search" >
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.createdAt | date:'medium' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
              <div class="header-name d-flex align-items-center" (click)="sortData('name')">
                Name
                <mat-icon class="sorting-icon" *ngIf="sorting.column === 'name'">
                  {{ sorting.direction === 1 ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </div>
              <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'name')">
                <input matInput placeholder="Search" >
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.name}}
            </td>
          </ng-container>

          <ng-container matColumnDef="tableId">
            <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
              <div class="header-name d-flex align-items-center" (click)="sortData('tableId')">
                Referance Id
                <mat-icon class="sorting-icon" *ngIf="sorting.column === 'tableId'">
                  {{ sorting.direction === 1 ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </div>
              <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'tableId')">
                <input matInput placeholder="Search" >
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.tableId}}
            </td>
          </ng-container>

          <ng-container matColumnDef="userCodeId">
            <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
              <div class="header-name d-flex align-items-center" (click)="sortData('userCodeId')">
                user Code
                <mat-icon class="sorting-icon" *ngIf="sorting.column === 'userCodeId'">
                  {{ sorting.direction === 1 ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </div>
              <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'userCodeId')">
                <input matInput placeholder="Search" >
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.userCodeId}}
            </td>
          </ng-container>
  
       
         <ng-container matColumnDef="amountCurrency1" *ngIf="!isLoading">
              <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
                <div class="header-name d-flex align-items-center" (click)="sortData('amountCurrency1')">
                  Amount 1 / Currency Base
                  <mat-icon class="sorting-icon" *ngIf="sorting.column === 'amountCurrency1'">
                    {{ sorting.direction === 1 ? 'arrow_upward' : 'arrow_downward' }}
                  </mat-icon>
                </div>
                <mat-form-field appearance="outline" class="small-input">
                  <input matInput placeholder="Search Amount" (input)="onInputChange($event, 'amount1')" numbersOnly>
                </mat-form-field>
                <mat-form-field appearance="outline" class="small-input">
                  <input matInput placeholder="Search Currency" (input)="onInputChange($event, 'currencyId1')">
                </mat-form-field>
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.amount1}} /{{element.currencyId1}}
              </td>
            </ng-container>

          
            <ng-container matColumnDef="amountCurrency2" *ngIf="!isLoading">
              <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
                <div class="header-name d-flex align-items-center" (click)="sortData('amountCurrency2')">
                  Amount 2 / Currency Quote
                  <mat-icon class="sorting-icon" *ngIf="sorting.column === 'amountCurrency2'">
                    {{ sorting.direction === 1 ? 'arrow_upward' : 'arrow_downward' }}
                  </mat-icon>
                </div>
                <mat-form-field appearance="outline" class="small-input">
                  <input matInput placeholder="Search Amount" (input)="onInputChange($event, 'amount2')" numbersOnly>
                </mat-form-field>
                <mat-form-field appearance="outline" class="small-input">
                  <input matInput placeholder="Search Currency" (input)="onInputChange($event, 'currencyId2')">
                </mat-form-field>
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.amount2}} /{{element.currencyId2}}
              </td>
            </ng-container>

  
          <!-- <ng-container matColumnDef="category1" *ngIf="!isLoading">
            <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
              <div class="header-name d-flex align-items-center" (click)="sortData('category1')">
                Category 1
                <mat-icon class="sorting-icon" *ngIf="sorting.column === 'category1'">
                  {{ sorting.direction === 1 ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </div>
              <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'category1')">
                <input matInput placeholder="Search" alphaNumeric>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element"> {{element.category1}} </td>
          </ng-container>
  
          <ng-container matColumnDef="category2" *ngIf="!isLoading">
            <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
              <div class="header-name d-flex align-items-center" (click)="sortData('category2')">
                Category 2
                <mat-icon class="sorting-icon" *ngIf="sorting.column === 'category2'">
                  {{ sorting.direction === 1 ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </div>
              <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'category2')">
                <input matInput placeholder="Search" alphaOnly>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element"> {{element.category2}} </td>
          </ng-container> -->
  
          <!-- <ng-container matColumnDef="type1" *ngIf="!isLoading">
            <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
              <div class="header-name d-flex align-items-center" (click)="sortData('type1')">
                Type 1
                <mat-icon class="sorting-icon" *ngIf="sorting.column === 'type1'">
                  {{ sorting.direction === 1 ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </div>
              <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'type1')">
                <input matInput placeholder="Search" numbersOnly>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element"> {{convert(element.type1)}} </td>
          </ng-container>
  
          <ng-container matColumnDef="type2" *ngIf="!isLoading">
            <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
              <div class="header-name d-flex align-items-center" (click)="sortData('type2')">
                Type 2
                <mat-icon class="sorting-icon" *ngIf="sorting.column === 'type2'">
                  {{ sorting.direction === 1 ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </div>
              <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'type2')">
                <input matInput placeholder="Search" numbersOnly>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element"> {{convert(element.type2)}} </td>
          </ng-container> -->
  
         
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{ 'hide-data': isLoading }"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="9999" class="p-4">
              <strong class="text-secondary">No record found!</strong>
            </td>
          </tr>
        </table>
        <div *ngIf="isLoading" class="spinner-container">
          <mat-progress-spinner color="primary" mode="indeterminate" diameter="50">
          </mat-progress-spinner>
        </div>
      </div>
      <mat-paginator [length]="totalRows" [pageIndex]="currentPage" [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions" showFirstLastButtons aria-label="Select page of periodic elements"
        (page)="pageChanged($event)">
      </mat-paginator>
    </c-card-body>
  </c-card>